<div class="flex-height">
    @if (showFilter) {
        <process-editor-filter
            class="filter"
            (onApplyFilter)="loadDiagram($event)"
            [isViewer]="readOnly"
            #filter
        ></process-editor-filter>
    }
    <div id="process-editor" #processEditor [hidden]="!isFilterApplied">
        @if (!readOnly) {
            <process-editor-menubar class="menubar" [actions]="actions"></process-editor-menubar>
        }
        <process-editor-toolbar
            class="toolbar"
            [readOnly]="readOnly"
            [actions]="actions"
            [fullscreenContainer]="processEditor"
            [processEditor]="this"
        ></process-editor-toolbar>

        <div class="editor">
            <as-split unit="percent" #split="asSplit" (dragEnd)="onDragEnd()">
                <as-split-area
                    [size]="splitConfig.shapeArea.size"
                    [visible]="splitConfig.shapeArea.visible"
                    #shapeArea="asSplitArea"
                >
                    <div id="shapes-sidebar" class="shapes-sidebar">
                        <process-editor-shape-sidebar #shapesSidebar [graph]="graph">
                        </process-editor-shape-sidebar>
                    </div>
                </as-split-area>
                <as-split-area
                    [size]="splitConfig.graphArea.size"
                    #graphArea="asSplitArea"
                    class="graph-split-area"
                >
                    <div class="graph">
                        <div
                            #graphContainer
                            id="graphContainer"
                            tabindex="-1"
                            class="graph-container"
                            (wheel)="zoomGraph($event)"
                            (contextmenu)="panContextMenuIntercept($event)"
                        ></div>
                        <canvas #gridCanvas></canvas>
                        @if (isLoading) {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </as-split-area>

                <as-split-area
                    [size]="splitConfig.propertiesArea.size"
                    #propertiesArea="asSplitArea"
                >
                    @if (propertiesLoaded) {
                        <process-editor-properties-sidebar
                            id="properties"
                            [readOnly]="readOnly"
                            [graph]="graph"
                            [processMetadata]="graph.diagramData && graph.diagramData.metadata"
                            [currentOrganizationId]="currentOrganizationId"
                            [currentBusinessDimensionId]="currentBusinessDimensionId"
                            [cerrixTab]="tab"
                        >
                        </process-editor-properties-sidebar>
                    }
                </as-split-area>
            </as-split>
        </div>

        <process-editor-footer
            (onProcessSelected)="loadDiagram($event)"
            [path]="path"
            class="footer"
            #footer
        >
        </process-editor-footer>

        @if (!readOnly) {
            <cerrix-contextmenu
                [menu]="contextMenu"
                [container]="graphContainer"
                [openOnDrag]="false"
                theme="processeditor"
            ></cerrix-contextmenu>
        }
    </div>
</div>
